import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTosGuard } from '../hook/useTosGuard';

const PrivateRoute = ({ requiredPermission, allowedRoles }) => {
    const { user } = useAuth();
    const tosChecked = useTosGuard();

    if (!user) {
        return <Navigate to="/sign-in" replace />;
    }

    if (!tosChecked) {
        // Return null or a loader while ToS is being checked
        return null;
    }

    if (allowedRoles && !allowedRoles.includes(user.role)) {
        return <Navigate to="/access-denied" replace />;
    }

    // Permission check
    if (requiredPermission) {
        // Admin bypass
        if (user.role === 'admin') return <Outlet />;
        
        // Check permissions
        if (user.permissions && user.permissions.includes(requiredPermission)) {
            return <Outlet />;
        }
        
        // No permission
        return <Navigate to="/access-denied" replace />;
    }

    return <Outlet />;
};

export default PrivateRoute;
